// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1YaQy","content":"styles_content__2sd-p","row":"styles_row__Lq5h3","footer":"styles_footer__3Egk5","phraseLength":"styles_phraseLength__xB4pt"};